/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
const React = require('react');
const BackIcon = require('@andes/icons/ArrowLeft20');

const BackTo = ({ children, path }) => {
  function url() {
    if (document.referrer) {
      window.history.back();
    } else window.location.href = path;
  }

  return (
    <div className="back-to-container">
      <a className="back-to-arrow" href="##" onClick={url}>
        <BackIcon />
        <span className="back-to-text"> {children}</span>
      </a>
    </div>
  );
};

module.exports = BackTo;
